import { Loader2 } from 'lucide-react';
export function Spinner({ label }: { label?: string }) {
  return (
    <div className="flex items-center gap-2 p-6 muted">
      <Loader2 className="animate-spin" size={16} /> {label ?? 'Yükleniyor…'}
    </div>
  );
}
export function ErrorBox({ error }: { error: unknown }) {
  const msg = error instanceof Error ? error.message : String(error);
  return <div className="m-3 rounded border border-red-300 bg-red-50 p-3 text-red-800 dark:bg-red-950/40 dark:text-red-200">{msg}</div>;
}
